import { Pipe, PipeTransform } from "@angular/core";
import { UtilFileHelper } from "@rr/shared-util";

@Pipe({
  name: "rrUiCoreFileSize",
  standalone: true,
})
export class UiCoreFileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    return UtilFileHelper.getFileSize(bytes);
  }
}
